import { GetFileExtension, getJwt, imageFormats } from '@app/helpers';
import Axios from 'axios';

export const wiewArquivoAnexo = async (id: string, nomeDoArquivo: string, url: string) => {
  var url = window.location.origin + `${url}/${id}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(response => {
    let file = undefined;
    let fileUrl = undefined;
    const fileExtension = GetFileExtension(nomeDoArquivo);
    if (fileExtension === 'pdf') {
      file = new Blob([response.data], { type: 'application/pdf' });
      fileUrl = URL.createObjectURL(file);
    } else if (imageFormats.includes(fileExtension)) {
      file = new Blob([response.data], { type: 'image/' + fileExtension });
      fileUrl = URL.createObjectURL(file);
    }
    if (fileUrl !== undefined) var resp = window.open(fileUrl);
  });
};

export const downloadAnexo = async (id: string, nomeDoArquivo: string, url: string) => {
  let urlBase = window.location.origin;
  await Axios.get(urlBase + `${url}/${id}`, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
  })
    .then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeDoArquivo);
      link.setAttribute('id', 'downloadArquivoAnexo');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadArquivoAnexo').outerHTML = '';
    })
    .catch(e => {
      throw e;
    });
};

export const downloadAnexoPost = async (nomeDoArquivo: string, url: string, filtros: any) => {
  let urlBase = window.location.origin;
  await Axios.post(`${urlBase}${url}`, filtros, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
  })
    .then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeDoArquivo);
      link.setAttribute('id', 'downloadArquivoAnexo');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadArquivoAnexo').outerHTML = '';
    })
    .catch(e => {
      throw e;
    });
};